import { CancelRequisitionDocument, CancelRequisitionMutation } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

import type { AtsRequisition } from 'modules/ats/hooks/requisitions/useRequisition'

export const useCancelRequisition = (requisition: AtsRequisition) => {
  const [cancelRequisitionMutation, { loading }] = useMutation(CancelRequisitionDocument, {
    extractorFn: (data: CancelRequisitionMutation) => data.atsMutations.cancelAtsRequisition,
  })

  return {
    loading,
    cancelRequisition() {
      return cancelRequisitionMutation({
        variables: { id: requisition.id },
        update(cache) {
          cache.evict({ id: cache.identify(requisition) })
        },
      })
    },
  }
}
